// Copyright ID Business Solutions Ltd. 2024

import styled from 'styled-components';

export const ImportSelectedWrapper = styled.div`
  text-wrap: nowrap;
`;
